import { render, staticRenderFns } from "./ProTagWithUpgradeTooltip.vue?vue&type=template&id=1edc18df&scoped=true"
import script from "./ProTagWithUpgradeTooltip.vue?vue&type=script&lang=js"
export * from "./ProTagWithUpgradeTooltip.vue?vue&type=script&lang=js"
import style0 from "./ProTagWithUpgradeTooltip.vue?vue&type=style&index=0&id=1edc18df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc18df",
  null
  
)

export default component.exports